
export const createConditionForm = () => {
    return  [{
        check: ({ field }) => {
            return field?.key.startsWith('topics.') && field?.key.endsWith('refTopicAnalysisStatus')
        },
        disableTopicAnalysisStatusField: ({ record, props }) => {
            const { viewOnly } = props
            if (viewOnly) {
                return true
            } else if (!record.refLabTopic.haveChildren && record.refLabTopic.refLabFormula.key == 'Acceptance') {
                return false
            } else {
                return true
            }
        },
    }, {
        check: ({ field }) => {
            return field?.key.startsWith('topics.') && field?.key.endsWith('refTopicRepeatOption')
        },
        customRenderInputProp: ({ record, props }) => {
            const { viewOnly } = props
            const disableChecker =  viewOnly || !record.refLabTopic?.isCanChangeRepeatOption;
            const inVisible = !record.refTopicAnalysisStatus || record.refTopicAnalysisStatus.key == 'Accept'
            return {
                disabled: disableChecker,
                visible: !inVisible,
            }
        },
    }]
}